var wholesalePassword = function wholesalePassword() {
  var wholesaleportal = document.querySelector('.wholesale-portal');
  if (!wholesaleportal) {
    return;
  }

  // Function to set a session cookie
  function setSessionCookie(name, value) {
    var expirationDate = new Date();
    expirationDate.setHours(expirationDate.getHours() + 1); // Expires in 1 hour
    document.cookie = name + "=" + value + ";expires=" + expirationDate.toUTCString() + ";path=/";
  }

  // Function to get a cookie by name
  function getCookie(name) {
    var match = document.cookie.match(new RegExp('(^| )' + name + '=([^;]+)'));
    return match ? match[2] : null;
  }
  document.getElementById('wholesale-portal-form').addEventListener('submit', function (event) {
    event.preventDefault();
    var password = document.getElementById('wholesale-password').value;

    // Replace 'YourPassword' with the actual password you want to check
    var correctPassword = wholesaleportal.dataset.id;

    // Compare entered password with the correct password
    if (password === correctPassword) {
      // Set the session cookie for a successful login
      setSessionCookie('wholesale_access', 'granted');

      // Redirect to the desired page upon successful password entry
      window.location.href = '/pages/wholesale-landing'; // Modify this URL with the desired redirect URL
    } else {
      alert('Incorrect password. Please try again.');
    }
  });
};
export { wholesalePassword };